import { Action } from '@ngrx/store';
import { IContact } from '@cemex-core/cmx-api/models/contact/contact';
import { ContactsTypesTypes } from '../../../../constants/contacts-types';
import { ILocationConfigUnit } from '@ordersnproducts/modules/order-builder/modules/location/models/location-config.interface';

export const LOAD_INITIAL_STATE = '[Receiving Persons] Load initial state';
export const LOAD = '[Receiving Persons] Load';
export const LOAD_COMPLETE = '[Receiving Persons] Load Complete';
export const LOAD_FAIL = '[Receiving Persons] Load Fail';
export const TOGGLE_AVAILABLE = '[Receiving Persons] Toggle Available';
export const SET = '[Receiving Persons] Set';
export const ADD_MULTIPLE = '[Receiving Persons] Add contact to multiple selected persons';
export const SET_MULTIPLE = '[Receiving Persons] Set multiple selected persons';
export const REMOVE_SELECTED_PERSON = '[Receiving Persons] Remove Selected';
export const TOGGLE_CREATE_FORM_VISIBLE = '[Receiving Persons] Toggle create form visible';
export const LOAD_DEFAULT_CONTACT = '[Receiving Persons] Load default contact';
export const LOAD_DEFAULT_CONTACT_COMPLETE = '[Receiving Persons] Load default contact Complete';
export const LOAD_DEFAULT_CONTACT_FAIL = '[Receiving Persons] Load default contact Fail';
export const ADD_CONTACT = '[Receiving Persons] Add contact';
export const ADD_LOCAL_CONTACT = '[Receiving Persons] Add contact for select options';
export const ADD_CONTACT_SUCCESS = '[Receiving Persons] Add contact Success';
export const CONTACT_DELETE_BY_ID = '[Receiving Persons] DELETE BY ID';
export const LOAD_DEFAULT_EMAIL = '[Receiving Persons] LOAD DEFAULT EMAIL';
export const LOAD_DEFAULT_EMAIL_COMPLETE = '[Receiving Persons] LOAD DEFAULT EMAIL COMPLETE';
export const LOAD_DEFAULT_EMAIL_FAIL = '[Receiving Persons] LOAD DEFAULT EMAIL FAIL';
export const DELETE_CONTACT = '[Receiving Persons] DELETE CONTACT';
export const DELETE_CONTACT_FAILURE = '[Receiving Persons] DELETE CONTACT FAIL';
export const DELETE_CONTACT_SUCCESS = '[Receiving Persons] DELETE CONTACT SUCCESS';
export const DELETE_CONTACT_RESET_STATUS = '[Receiving Persons] DELETE CONTACT RESET STATUS';
export class ReceivingPersonsLoadInitialState implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) { }
}

export class ReceivingPersonsLoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: { contactType: ContactsTypesTypes[]; jobsiteId: number }) { }
}

export class ReceivingPersonsLoadCompleteAction implements Action {
  readonly type = LOAD_COMPLETE;

  constructor(public payload: IContact[]) { }
}

export class ReceivingPersonsLoadFailAction implements Action {
  readonly type = LOAD_FAIL;

  constructor(public payload: any) { }
}

export class ReceivingPersonsToggleAvailability implements Action {
  readonly type = TOGGLE_AVAILABLE;

  constructor(public payload: boolean) { }
}

export class ReceivingPersonsCreateFormVisible implements Action {
  readonly type = TOGGLE_CREATE_FORM_VISIBLE;

  constructor(public payload: boolean) { }
}

export class ReceivingPersonsSetAction implements Action {
  readonly type = SET;

  constructor(public payload: IContact, public refreshPersons = false) { }
}

export class ReceivingMultiplePersonsAddAction implements Action {
  readonly type = ADD_MULTIPLE;

  constructor(public payload: IContact, public refreshPersons = false) { }
}
export class ReceivingMultiplePersonsSetAction implements Action {
  readonly type = SET_MULTIPLE;

  constructor(public payload: IContact[], public refreshPersons = false) { }
}

export class ReceivingPersonsAddContactAction implements Action {
  readonly type = ADD_CONTACT;

  constructor(public payload: { contact: IContact }) { }
}

export class ReceivingPersonsAddContactSuccessAction implements Action {
  readonly type = ADD_CONTACT_SUCCESS;
}

export class ReceivingPersonsAddLocalContactAction implements Action {
  readonly type = ADD_LOCAL_CONTACT;

  constructor(public payload: IContact) { }
}

export class RemoveSelectedReceivingPerson implements Action {
  readonly type = REMOVE_SELECTED_PERSON;

  constructor(public payload: null = null) { }
}

export class DefaultReceivingPersonsLoadAction implements Action {
  readonly type = LOAD_DEFAULT_CONTACT;

  constructor(public payload: { jobsiteCode: string }) { }
}

export class DefaultReceivingPersonsLoadCompleteAction implements Action {
  readonly type = LOAD_DEFAULT_CONTACT_COMPLETE;

  constructor(
    public payload: { contactId: number; contactName: string; contactPhone: string; contactCode: string }[],
  ) { }
}

export class DefaultReceivingPersonsLoadFailAction implements Action {
  readonly type = LOAD_DEFAULT_CONTACT_FAIL;

  constructor(public payload: any) { }
}
export class ContactDeleteById implements Action {
  readonly type = CONTACT_DELETE_BY_ID;
  constructor(public payload: any) { }
}
export class DefaultEmailAction implements Action {
  readonly type = LOAD_DEFAULT_EMAIL;
  constructor() { }
}

export class DefaultEmailCompleteAction implements Action {
  readonly type = LOAD_DEFAULT_EMAIL_COMPLETE;
  constructor(public payload: string) { }
}
export class DefaultEmailFailAction implements Action {
  readonly type = LOAD_DEFAULT_EMAIL_FAIL;
}

export class DeleteContactAction implements Action {
  readonly type = DELETE_CONTACT;

  constructor(
  public payload: { contactSelectedForDeleteId: string; reasonControl: string; },
  ) {}
}
export class DeleteContactSuccessAction implements Action {
  readonly type = DELETE_CONTACT_SUCCESS;
}
export class DeleteContactFailureAction implements Action {
  readonly type = DELETE_CONTACT_FAILURE;
}
export class DeleteContactResetAction implements Action {
  readonly type = DELETE_CONTACT_RESET_STATUS;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type ReceivingPersonsActions =
  | ReceivingPersonsLoadInitialState
  | ReceivingPersonsLoadAction
  | ReceivingPersonsLoadCompleteAction
  | ReceivingPersonsLoadFailAction
  | ReceivingPersonsSetAction
  | RemoveSelectedReceivingPerson
  | ReceivingPersonsToggleAvailability
  | ReceivingPersonsCreateFormVisible
  | DefaultReceivingPersonsLoadAction
  | DefaultReceivingPersonsLoadCompleteAction
  | DefaultReceivingPersonsLoadFailAction
  | ReceivingPersonsAddContactSuccessAction
  | ReceivingPersonsAddContactAction
  | ReceivingPersonsAddLocalContactAction
  | ReceivingMultiplePersonsSetAction
  | ReceivingMultiplePersonsAddAction
  | ContactDeleteById
  | DefaultEmailAction
  | DefaultEmailCompleteAction
  | DefaultEmailFailAction
  | DeleteContactAction
  | DeleteContactFailureAction
  | DeleteContactSuccessAction
  | DeleteContactResetAction;
